<template>
  <div>
    <HeroComp />
    <WhatIDo />
    <WhyMe />
    <CTA />
    <FAQ />
    <LogoStrip />
  </div>
</template>

<script>
import HeroComp from '@/components/HeroComp.vue';
import WhatIDo from '@/components/WhatIDo.vue';
import WhyMe from '@/components/WhyMe.vue';
import CTA from '@/components/CTA.vue';
import FAQ from '@/components/FAQ.vue';
import LogoStrip from '@/components/LogoStrip.vue';

export default {
  components: {
    HeroComp,
    WhatIDo,
    WhyMe,
    CTA,
    FAQ,
    LogoStrip
  }
}
</script>
